import React, { useState, useEffect, useRef } from 'react';
import '../../css/common/RedirectCountdown.css';

const RedirectCountdown = ({ seconds = 10, onComplete }) => {
  const [timeLeft, setTimeLeft] = useState(seconds);
  const progressRef = useRef(null);

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          onComplete();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [onComplete]);

  return (
    <div className="redirect-countdown">
      <div className="redirect-progress" ref={progressRef}>
        <div 
          className="redirect-bar" 
          style={{ 
            width: `${(timeLeft / seconds) * 100}%`,
            transition: 'width 1s linear'
          }}
        />
      </div>
      <p>Redirecting in {timeLeft} seconds...</p>
    </div>
  );
};

export default RedirectCountdown;
